import React, { useState } from "react";
import {
  Button,
  Col,
  Row,
  Modal,
  Form,
  Card,
  Badge,
  Alert,
  Accordion,
} from "react-bootstrap";
import Mern from "../assets/products/mern.png";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Product from "./Product";
import Footer from "../components/Footer";
import Html from "../assets/products/fullstack/html5.png";
import Css from "../assets/products/fullstack/css.png";
import Js from "../assets/products/fullstack/js.png";
import ReactJs from "../assets/products/fullstack/react.png";
import Mongo from "../assets/products/fullstack/mongo.png";
import Node from "../assets/products/fullstack/node.png";
import Git from "../assets/products/fullstack/git.png";
import Sql from "../assets/products/fullstack/sql.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { Post } from "../payment/PaymentPost";

const SingleProduct = () => {
  const navigate = useNavigate();

  const [isChecked, setIsChecked] = useState(false);
  const isLogged = useSelector((state) => state.user.isLoggedIn);
  const user = useSelector((state) => state.user.user);

  const getData = (data) => {
    return fetch(`https://htacademy.in/api/v1/payment`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .catch((err) => console.log(err));
  };

  const makePayment = () => {
    if (isLogged) {
      let amount = 8000;
      if (isChecked) {
        amount = 5000;
      }
      getData({
        amount: amount,
        email: user[0].email,
        mobile: user[0].phone,
        name: user[0].name,
        total: 8000,
        course: "Full Stack Web Development",
      }).then((response) => {
        var information = {
          action: "https://securegw.paytm.in/theia/processTransaction",
          params: response,
        };
        Post(information);
      });
    } else {
      navigate("/login");
    }
  };

  const confirmHandler = () => {
    if (isLogged) {
      getData({
        amount: 1000,
        email: user[0].email,
        mobile: user[0].phone,
        name: user[0].name,
        total: 8000,
        course: "Full Stack Web Development",
      }).then((response) => {
        var information = {
          action: "https://securegw.paytm.in/theia/processTransaction",
          params: response,
        };
        Post(information);
      });
    } else {
      navigate("/login");
    }
  };
  return (
    <>
      <Row className="mx-0 stud-test bg-blue text-white">
        <Col md={8} className="pt-1">
          <h4 className="pt-3">
            Become a Full Stack Developer with VK Learning Bootcamp Program
          </h4>
          <p>
            <ul>
              <li>
                Upskill in DSA & System Design with specialization in Full Stack
                Development
              </li>
              <li>
                Build real-world projects by mastering React, MERN, JavaScript,
                etc.
              </li>
              <li>
                Learn the essential Full Stack development concepts from scratch
              </li>
            </ul>
          </p>
          <p>
            Fullstack web development -MERN STACK, nodejs, react, mongodb,
            javascript, HTML, CSS, express, API, & more
          </p>
          <p>
            <ul className="d-flex list">
              <li>Online Live Classes</li>
              <li className="mx-5">Career Guidance</li>
            </ul>
          </p>
          <p className="d-flex justify-content-between">
            <span>
              To confirm your seat pay now &nbsp;
              <Button
                variant="outline-warning"
                size="sm"
                className="px-3"
                onClick={confirmHandler}
              >
                Pay 1000
              </Button>
            </span>
            <span className="fw-bold">
              Next batch:&nbsp; <b className="text-warning">January 2023</b>
            </span>
          </p>
          {/* <p>
            <Button variant="outline-warning" className="px-5 mx-1">
              Download Curriculum
            </Button>
          </p> */}
        </Col>
        <Col md={4}>
          <img src={Mern} alt="" className="img-fluid shadow" />
        </Col>
      </Row>
      <Row className="mx-0 course-det py-3">
        <Col md={8} className="course-det">
          <h4>Online Full Stack Development Bootcamp</h4>
          <p>
            A 6 month long, rigorous, online program designed by industry
            experts, we provide in-depth access to an industry tested
            curriculum. Taught by live instructors, with continuous mentor
            support & flexible timings, this program doesn’t require any coding
            background. With a strong focus on imparting industry relevant
            skills, we will help you land a job in your dream product based
            company.
          </p>
          <Row>
            <Col md={4} className="pb-2">
              <Card className="shadow text-center">
                <Card.Body>
                  <h1>
                    <i className="fas fa-laptop-code border rounded-circle p-3"></i>
                  </h1>
                  <h6 className="fw-bold">1000+ hours of Coding Practice</h6>
                  <p>
                    We strongly believe in learning by doing. Go through a
                    structured, rigorous problem solving daily.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="pb-2">
              <Card className="shadow text-center">
                <Card.Body>
                  <h1>
                    <i className="fas fa-chalkboard-teacher border rounded-circle p-3"></i>
                  </h1>
                  <h6 className="fw-bold">Live, Interactive Classes</h6>
                  <p>
                    Daily live classes, taught by experienced, highly qualified
                    working professionals.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="pb-2">
              <Card className="shadow text-center">
                <Card.Body>
                  <h1>
                    <i className="fas fa-project-diagram border rounded-circle p-3"></i>
                  </h1>
                  <h6 className="fw-bold">Real World Projects</h6>
                  <p>
                    Strengthen your resume and get industry ready by working on
                    real life full stack projects.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="py-4">
            <Col>
              <h4 className="pb-2">
                What roles does a Full Stack Developer play?
              </h4>
              <Row>
                <Col md={4}>
                  <Alert className="shadow" variant="warning">
                    <h6 className="fw-bold">Full-Stack Developer</h6>
                    <p>
                      Full-stack developers develop both the front-end and the
                      Backend (server-side) of the application, deploy, debug
                      and maintain their databases and servers.
                    </p>
                  </Alert>
                </Col>
                <Col md={4}>
                  <Alert className="shadow" variant="success">
                    <h6 className="fw-bold">Front-End Developer</h6>
                    <p>
                      Create the frontend of websites using various libraries
                      and frameworks, used by front end tools like HTML, CSS,
                      JavaScript, Bootstrap and React etc.
                    </p>
                  </Alert>
                </Col>
                <Col md={4}>
                  <Alert className="shadow" variant="danger">
                    <h6 className="fw-bold">Backend Developer</h6>
                    <p>
                      To develop Server Side programming by developing web
                      applications connect with database used by front end tools
                      like Node.js, ExpressJS, Python, MongoDB etc.
                    </p>
                  </Alert>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="pb-4">
            <Col>
              <h4>Full Stack Development Curriculum</h4>
              <Accordion defaultActiveKey="0" flush>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>HTML</Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>Introduction to HTML</li>
                      <li>Browsers and HTML</li>
                      <li>Editor’s Offline and Online</li>
                      <li>Tags, Attribute and Elements</li>
                      <li>Doctype Element</li>
                      <li>Comments</li>
                      <li>Headings, Paragraphs, and Formatting Text</li>
                      <li>Lists and Links</li>
                      <li>Images and Tables</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>CSS</Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>Introduction to CSS</li>
                      <li>Applying CSS to HTML</li>
                      <li>Selectors, Properties and Values</li>
                      <li>CSS Colors and Backgrounds</li>
                      <li>CSS Box Model</li>
                      <li>CSS Margins, Padding, and Borders</li>
                      <li>CSS Text and Font Properties</li>
                      <li>CSS General Topics</li>
                      <li>CSS Flexbox and Grid</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>JavaScript</Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>Introduction to JavaScript</li>
                      <li>Applying JavaScript (internal and external)</li>
                      <li>Understanding JS Syntax</li>
                      <li>Introduction to Document and Window Object</li>
                      <li>Variables and Operators</li>
                      <li>Data Types and Num Type Conversion</li>
                      <li>Math and String Manipulation</li>
                      <li>Objects and Arrays</li>
                      <li>Date and Time</li>
                      <li>Conditional Statements</li>
                      <li>Switch Case </li>
                      <li>Looping in JS </li>
                      <li>Functions</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>ReactJS</Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>Introduction to React</li>
                      <li>Templating using JSX</li>
                      <li>Components, State and Props</li>
                      <li>Lifecycle of Components</li>
                      <li>Rendering List and Portals</li>
                      <li>Error Handling</li>
                      <li>Hooks</li>
                      <li>Routers</li>
                      <li>Redux / Redux Tool Kit</li>
                      <li>Axios</li>
                      <li>React-Bootstrap</li>
                      <li>Deploy ReactJS App</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>NodeJS</Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>Node js Overview</li>
                      <li>Basics and Setup</li>
                      <li>Node js Console</li>
                      <li>Node js Modules</li>
                      <li>MongoDB with Nodejs</li>
                      <li>Express JS</li>
                      <li>Authentication</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>MongoDB</Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>SQL and NoSql Concepts</li>
                      <li>Introduction to MongoDB (No-Sql)</li>
                      <li>Collections in MongoDB</li>
                      <li>Documents in MongoDB</li>
                      <li>MongoDB with NodeJS</li>
                      <li>MongoDB Atlas Introduction</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>MySQL</Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>Introduction to MySQL</li>
                      <li>Creating Databases and Users</li>
                      <li>Creating Database Tables</li>
                      <li>
                        Inserting,Retrieving and Updating Data in to the
                        Database
                      </li>
                      <li>Altering Tables after Creation</li>
                      <li>More about Sql</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>Version Control System</Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>Introduction to Version Control</li>
                      <li>Introduction to Git</li>
                      <li>Git Installation and GitHub Introduction</li>
                      <li>Create Repositories</li>
                      <li>Remote and Clone Repo's</li>
                      <li>Command-line Scripting</li>
                      <li>More about Git</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>

          <Row className="pb-4">
            <Col>
              <h4 className="pb-2">Tools Covered</h4>
              <p>
                <img src={Html} alt="" className="tools shadow mx-2 p-3" />
                <img src={Css} alt="" className="tools shadow mx-2 p-3" />
                <img src={Js} alt="" className="tools shadow mx-2 p-3" />
                <img src={ReactJs} alt="" className="tools shadow mx-2 p-3" />
                <img src={Mongo} alt="" className="tools shadow mx-2 p-3" />
                <img src={Node} alt="" className="tools shadow mx-2 p-3" />
                <img src={Sql} alt="" className="tools shadow mx-2 p-3" />
                <img src={Git} alt="" className="tools shadow mx-2 p-3" />
              </p>
            </Col>
          </Row>
        </Col>
        <Col md={4} className="course-details">
          <Card className="shadow sticky-top side">
            <Card.Body>
              <h6 className="d-flex justify-content-between align-items-center py-1">
                <span>
                  <i className="fas fa-calendar-alt text-secondary pe-2"></i>
                  Course Duration
                </span>
                <span>6 months</span>
              </h6>
              <h6 className="d-flex justify-content-between align-items-center py-1">
                <span>
                  <i className="fas fa-user-graduate text-secondary pe-2"></i>
                  Life Time Access
                </span>
                <span>Yes</span>
              </h6>
              <h6 className="d-flex justify-content-between align-items-center py-1">
                <span>
                  <i className="fas fa-file-alt text-secondary pe-2"></i>Resume
                  Preparation
                </span>
                <span>Yes</span>
              </h6>
              <h6 className="d-flex justify-content-between align-items-center py-1">
                <span>
                  <i className="fas fa-user-tie text-secondary pe-2"></i>
                  Interview Guidance
                </span>
                <span>Yes</span>
              </h6>
              <h6 className="mb-0 d-flex justify-content-between align-items-center">
                <span className="text-secondary">
                  <strike>
                    <i className="fa fa-rupee"></i> 21,000
                  </strike>
                </span>
                <Alert variant="danger" className="mb-0 py-2 px-4 fw-bolder">
                  <i className="fa fa-rupee"></i> 8,000
                </Alert>
              </h6>
              <p className="offer float-end text-secondary">
                * This is limited period of time only
              </p>
              <Form.Check
                type="checkbox"
                inline
                name="emi"
                value={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                id="emi"
                label="Flexible pay with 2 months each month 5,000"
              />
              <p className="offer float-end text-secondary text-end">
                * Terms & conditions apply <br />
                Fee once paid, wont be refunded.
              </p>
              <Button
                variant="warning"
                className="px-5 mt-2 mx-1 w-100"
                onClick={makePayment}
              >
                Enroll Now
              </Button>
            </Card.Body>
            <Card.Footer>
              <h5>Admission Process</h5>
              <p className="mb-0">
                <b>Step1:</b>&nbsp; Login / Register
              </p>
              <p className="mb-0">
                <b>Step2:</b>&nbsp; Subscribe with us
              </p>
              <p className="mb-0">
                <b>Step3:</b>&nbsp; Attend an online aptitude test
              </p>
              <p className="mb-0">
                <b>Step4:</b>&nbsp; Get up to 75% off on fees
              </p>
              <p className="mb-0">
                <b>Step5:</b>&nbsp; Pay remaining after discount and enroll
              </p>
              <p className="py-1 mb-0 text-secondary text-center">(OR)</p>
              <h6>
                Pay total amount and join directly <br />{" "}
                <span className="text-danger">
                  <Alert
                    variant="danger"
                    className="p-0 my-2 reserve"
                    onClick={confirmHandler}
                  >
                    (For reserve seat pay 1000/-)
                  </Alert>
                </span>
              </h6>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
      <Row className="mx-0 px-5 py-2"></Row>
      <Footer />
    </>
  );
};

export default SingleProduct;
